import { ListingBuyerSearchResultModel, ListingBuyerSearchResultModelConverter } from '@steelbuy/ts-shared';

import { AbstractSearchApiClient } from './api-client/AbstractSearchApiClient';

export class ListingBuyerSearchApiClient extends AbstractSearchApiClient<ListingBuyerSearchResultModel> {
    protected collectionControllerUri = 'api/universal/search-listings/';

    protected paginationControllerUri = 'api/universal/search-listings/';

    protected entityFetchUri = 'api/universal/search-listings/{id}/';

    protected override paginationSize = 10;

    protected modelConverter = new ListingBuyerSearchResultModelConverter();
}
